import { ActionTree } from 'vuex';
import {
  mutationSetSession,
  mutationSetSessionIsLoaded,
  mutationSetSessionIsLoading,
  mutationSetToken,
  mutationSetUser,
} from '../mutations/session.mutations';
import { SessionState } from '../stores/session.store';
import { RootState } from '../store';
import { SessionResponse } from '@/types/SessionResponse';
import service, { getSession, getToken } from '@/services/session.service';
import { translate } from '@/helpers/translation.helper';
import { TokenResponse } from '@/types/TokenResponse';
import { IUser } from '@/types/User';

export const actionFetchSession = 'fetchSession';
export const actionLoadSessionFailed = 'loadSessionFailed';

export const actionFetchToken = 'fetchToken';
export const actionSetToken = 'setToken';

export const actionFetchUser = 'fetchUser';
export const actionFetchUserSuccess = 'fetchUserSuccess';
export const actionFetchUserFailed = 'fetchUserFailed';

export const actionFetchTokenSuccess = 'fetchTokenSuccess';
export const actionFetchTokenFailed = 'fetchTokenFailed';

export const actions: ActionTree<SessionState, RootState> = {
  async [actionFetchSession]({ dispatch, commit }) {
    commit(mutationSetSessionIsLoading, true);
    commit(mutationSetSessionIsLoaded, false);
    dispatch(actionFetchUser);
    try {
      const response: SessionResponse = await getSession(true);
      if (response) {
        commit(mutationSetSession, response.session);
      } else {
        dispatch(actionFetchTokenFailed);
      }
    } catch (error) {
      dispatch(actionFetchTokenFailed, error);
    }
    commit(mutationSetSessionIsLoading, false);
    commit(mutationSetSessionIsLoaded, true);
  },
  async [actionLoadSessionFailed]({ dispatch }, error?: any) {
    console.error('Could not load session', error);
    dispatch('alert/showDangerAlert', translate('Could not load session'), { root: true });
  },
  async [actionFetchToken]({ dispatch }) {
    const milliseconds = 1000;
    const expiresIn = 1200;
    const { access_token = '' }: TokenResponse = await getToken();

    setTimeout(() => {
      dispatch(actionFetchToken);
    }, expiresIn * milliseconds);
    dispatch(actionFetchTokenSuccess, access_token);
  },
  async [actionFetchTokenSuccess]({ dispatch, commit }, access_token: string) {
    commit(mutationSetToken, access_token);
    dispatch('entity/loadPlanStatus', {}, { root: true });
  },
  [actionSetToken]({ commit }, access_token: string) {
    commit(mutationSetToken, access_token);
  },
  async [actionFetchUser]({ dispatch }) {
    try {
      const user: IUser = await service.getUser();
      dispatch(actionFetchUserSuccess, user);
    } catch (e) {
      dispatch(actionFetchUserFailed);
    }
  },
  async [actionFetchUserSuccess]({ commit }, user: IUser) {
    commit(mutationSetUser, user);
  },
  async [actionFetchUserFailed]({ dispatch }) {
    dispatch('alert/showDangerAlert', translate('Failed-to-fetch-user'), {
      root: true,
    });
  },
  async [actionFetchTokenFailed]({ dispatch }, error?: any) {
    console.error('Could not load session', error);
    dispatch('alert/showDangerAlert', translate('Could not load session'), { root: true });
  },
};
